import { Skeleton } from 'antd';
import { Column, Row } from 'farmhub-ui-core';

import { theme } from 'styled';

import { Img, Wrapper } from './styles';

const HeaderElectronicBillSkeleton = () => (
  <Wrapper>
    <Row justifyContent="space-between">
      <Row styles={{ gap: 12 }}>
        <Img>
          <Skeleton.Avatar size="large" />
        </Img>
        <Column styles={{ gap: theme.spacing.sm }}>
          <Skeleton.Input size="small" />
          <Skeleton.Input size="small" style={{ width: 250 }} />
        </Column>
      </Row>
    </Row>
  </Wrapper>
);

export default HeaderElectronicBillSkeleton;
